import { render, staticRenderFns } from "./damageTypeCpi.pug?vue&type=template&id=3b1329db&lang=pug&external"
import script from "./damageTypeCpi.js?vue&type=script&lang=js&external"
export * from "./damageTypeCpi.js?vue&type=script&lang=js&external"
import style0 from "./damageTypeCpi.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1329db')) {
      api.createRecord('3b1329db', component.options)
    } else {
      api.reload('3b1329db', component.options)
    }
    module.hot.accept("./damageTypeCpi.pug?vue&type=template&id=3b1329db&lang=pug&external", function () {
      api.rerender('3b1329db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/views/warrantyView/components/damageTypeCpi/index.vue"
export default component.exports